import DialogSearch from "../DialogSearch";
import TileModifierCode from "../../Tile/TileModifierCode";
import PropTypes from "prop-types";
import ModifierCode from "../../../Utility/Crud/ModifierCode";
import MainContext from "../../../Context/MainContext/MainContext";

export default class DialogSearchModifierCode extends DialogSearch {

    static contextType = MainContext; // For legacy class components

    /**
     * Searches for modifier codes by several name combinations or ID.
     *
     * @param {string} query The search query.
     * @returns A list of filtered modifier codes.
     */
    getSearchResults(query) {
        return ModifierCode.search(this.state.data, query, true);
    }

    /**
     * Gets the data that should be used in this dialog. Data can be manually
     * passed via the data prop, otherwise it falls back to the global list.
     *
     * @returns {array}
     */
    getData() {
        if (this.props.data) {
            return this.props.data;
        } else {
            return Object.values(this.context.modifierCodesIndexed);
        }
    }

    /**
     * @param {object} modifierCode The modifierCode object.
     * @returns A TileModifierCode component for this modifierCode.
     */
    renderTile(modifierCode) {
        return (
            <TileModifierCode
                key={ modifierCode.id }
                modifierCode={ modifierCode }
            />
        );
    }
}
